<template>
  <el-form label-position="right" label-width="110px">
    <el-form-item label="公司名称" required>
      <el-input v-model="invoice.invoiceTitle" placeholder="请输入公司名称(发票抬头)" size="mini"
                @input="inputInvoice"></el-input>
    </el-form-item>
    <el-form-item label="公司税号" required>
      <el-input v-model="invoice.taxIdentifyNumber" placeholder="请输入公司税号" size="mini"
                @input="inputInvoice"></el-input>
    </el-form-item>
    <hr style="margin: 20px 0">
    <el-form-item label="公司地址">
      <el-input v-model="invoice.companyAddress" placeholder="选填" size="mini"></el-input>
    </el-form-item>
    <el-form-item label="公司电话">
      <el-input v-model="invoice.companyPhone" placeholder="选填" size="mini"></el-input>
    </el-form-item>
    <el-form-item label="开户行名称">
      <el-input v-model="invoice.accountBankName" placeholder="选填" size="mini"></el-input>
    </el-form-item>
    <el-form-item label="开户行账号">
      <el-input v-model="invoice.accountBankid" placeholder="选填" size="mini"></el-input>
    </el-form-item>
    <hr style="margin: 20px 0">
    <el-form-item label="收票人手机号" required>
      <el-input v-model="invoice.checkTakerPhone" placeholder="请输入收票人手机号" size="mini"></el-input>
    </el-form-item>
    <el-form-item label="收票人邮箱" required>
      <el-input v-model="invoice.checkTakerEmail" placeholder="请输入收票人邮箱" size="mini"></el-input>
    </el-form-item>
    <hr style="margin: 20px 0" v-if="invoice.invoiceType && invoice.invoiceContent">
    <el-form-item label="发票类型" v-if="invoice.invoiceType && invoice.invoiceContent">
      <el-input v-model="invoice.invoiceType" size="mini" disabled></el-input>
    </el-form-item>
    <el-form-item label="发票内容" v-if="invoice.invoiceType && invoice.invoiceContent">
      <el-input v-model="invoice.invoiceContent" size="mini" disabled></el-input>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  name: 'InvoiceEdit',
  data () {
    return {
      invoice: {
        invoiceTitle: '',
        taxIdentifyNumber: '',
        companyAddress: '',
        companyPhone: '',
        accountBankName: '',
        accountBankid: '',
        checkTakerPhone: '',
        checkTakerEmail: '',
        invoiceType: '',
        invoiceContent: '*生产生活服务*经纪代理服务*代订住宿费'
      }
    }
  },
  methods: {
    init (invoiceType, invoice) {
      if (invoice) {
        this.invoice = {...invoice}
      }
      if (invoiceType) {
        this.invoice.invoiceType = invoiceType
        this.invoice.invoiceContent = '*生产生活服务*经纪代理服务*代订住宿费'
      }
    },
    inputInvoice () {
      if (this.invoice.invoiceType && this.invoice.invoiceContent) {
        this.invoice.invoiceBaiscId = 0
      }
    }
  }
}
</script>

<style scoped lang="less">
/deep/ .el-form-item {
  margin-bottom: 10px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/newPages/order/components/InvoiceEdit.vue